import { render, staticRenderFns } from "./ResourceSelector.vue?vue&type=template&id=5aa89da1&scoped=true&"
import script from "./ResourceSelector.vue?vue&type=script&lang=js&"
export * from "./ResourceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa89da1",
  null
  
)

export default component.exports